<template>
  <b-card style="position: relative;" class="mb-0">
    <b-row class="mb-2">
      <b-col :cols="12" v-if="$isMobile()">
        <a v-b-toggle.filter-list class="text-center" style="color: #6af">
          Show / hide filter options
        </a>
        <b-collapse id="filter-list" class="mt-2">
          <list-control label="Rows per Page" width="100%">
            <b-input
              block
              v-model="rowsPerPage"
              type="number"/>
          </list-control>

          <template v-if="enableSort">
            <list-control label="Sort By" width="50%">
              <b-select
                block
                v-model="sortBy"
                :options="sortByColumns"/>
            </list-control>

            <list-control label="Sort Order" width="50%">
              <b-select
                block
                v-model="sortOrder"
                :options="[{value: 1, text: 'ascending'}, {value: 0, text: 'descending'}]"/>
            </list-control>
          </template>

          <list-control
            label="Filter"
            width="100%"
            v-if="enableFilter">
            <b-input v-model="search" placeholder="Search active columns"/>
          </list-control>

          <list-control>
            <b-button @click="handleApply" variant="primary" >Apply</b-button>
          </list-control>
        </b-collapse>
      </b-col>
      <b-col v-else :cols="10">
        <list-control label="Rows per Page">
          <b-input
            block
            v-model="rowsPerPage"
            type="number"/>
        </list-control>

        <template v-if="enableSort">
          <list-control label="Sort By" width="180px">
            <b-select
              block
              v-model="sortBy"
              :options="sortByColumns"/>
          </list-control>

          <list-control label="Sort Order">
            <b-select
              block
              v-model="sortOrder"
              :options="[{value: 1, text: 'ascending'}, {value: 0, text: 'descending'}]"/>
          </list-control>
        </template>

        <list-control
          label="Filter"
          :width="enableSort ? '180px' : '320px'"
          v-if="enableFilter">
          <b-input v-model="search" placeholder="Search active columns"/>
        </list-control>

        <list-control>
          <b-button @click="handleApply" variant="primary" >Apply</b-button>
        </list-control>
      </b-col>
      <b-col :cols="12" :md="2" class="text-right">
        <list-control v-if="$isMobile()" :label="`${columns.length} columns`" width="100% !important">
          <b-dropdown text="Active columns">
            <div
              v-for="col in allColumns"
              :key="col.slug"
              class="dropdown-item text-body">
              <b-form-checkbox
                v-model="columns"
                name="columns"
                :value="col.slug">
                {{ titleCase(col.name) }}
              </b-form-checkbox>
            </div>
          </b-dropdown>
        </list-control>
        <list-control v-else :label="`${columns.length} columns`" width="100% !important">
          <b-dropdown text="Active columns">
            <div
              v-for="col in allColumns"
              :key="col.slug"
              class="dropdown-item text-body">
              <b-form-checkbox
                v-model="columns"
                name="columns"
                :value="col.slug">
                {{ titleCase(col.name) }}
              </b-form-checkbox>
            </div>
          </b-dropdown>
        </list-control>
      </b-col>
    </b-row>

    <div v-if="$isMobile()" style="overflow-x: auto;" class="alt-table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th :key="field.key" v-for="field in [{key: '#'}, ...tableFields, {key: '__action', label: ''}]">
              {{ field.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr :key="item.id" v-for="item in items">
            <td key="#" data-label="#">
              {{items.indexOf(item) + 1 + startPosition}}
            </td>
            <td :key="field.key" v-for="field in tableFields" :data-label="field.label">
              <!-- {{item[field.key]}} -->
              <template v-if="checkArrayContainsObject(item[field.key])">
                {{item[field.key].length}} rows
                <b-button
                variant="link"
                @click="open_table(item[field.key])">View details</b-button>
                
              </template>
              <template v-else-if="checkArrayContainsIDs(item[field.key])">
                {{item[field.key].length}} rows
                <b-button
                  variant="link"
                  @click="open_table(item[field.key])">
                        View details
                </b-button>
                
              </template>
              <template v-else-if="isObject(item[field.key])">
                {{[item[field.key]].length}} rows
                <b-button
                  variant="link"
                  @click="open_table(item[field.key])">
                        View details
                </b-button>
              
              </template>
              <template v-else>
                {{item[field.key]}}
              </template>
            </td>
            <td key="__action" data-label="">
              <div class="text-right">
                <b-button
                  v-if="enableAction"
                  variant="outline-primary"
                  size="sm"
                  @click="act(item)">
                  <i class="fa fa-eye"/>
                  <span class="ml-1" v-if="actionText">
                    {{actionText}}
                  </span>
                </b-button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else style="overflow-x: auto;">
      <!-- {{ tableFields }} -->
      <b-table
        show-empty
        hover
        small
        responsive="true"
        head-variant="dark"
        :items="items"
        :fields="[{key: '#'}, ...tableFields, {key: '__action', label: ''}]">
        <template v-slot:cell(#)="data">
          {{ data.index + 1 + startPosition }}
        </template>
        <template v-slot:cell()="data">
          <template v-if="checkArrayContainsObject(data.value)">
             {{data.value.length}} rows
            <b-button
             variant="link"
             @click="open_table(data)">View details</b-button>
            
          </template>
          <template v-else-if="checkArrayContainsIDs(data.value)">
            {{data.value.length}} rows
            <b-button
              variant="link"
              @click="open_table(data)">
                    View details
            </b-button>
             
          </template>
          <template v-else-if="isObject(data.value)">
             {{[data.value].length}} rows
            <b-button
              variant="link"
              @click="open_table(data)">
                    View details
            </b-button>
           
          </template>
          <template v-else>
            {{data.value}}
          </template>
        </template>

        <template v-slot:cell(__action)="data">
          <div class="text-right">
            <b-button
              v-if="enableAction"
              variant="outline-primary"
              size="sm"
              @click="act(data.item)">
              <i class="fa fa-eye"/>
              <span class="ml-1" v-if="actionText">
                {{actionText}}
              </span>
            </b-button>
          </div>
        </template>
        <template v-slot:empty="scope">
          <div class="my-5 py-5 text-center">
            <h6 v-if="items">{{ scope.emptyText }}</h6>
            <i v-else class="fa fa-spinner fa-spin fa-2x"/>
          </div>
        </template>
      </b-table>
    </div>
    
    <b-row v-if="rowCount" style="vertical-align: top; border-top: 1px solid lightgrey;" class="pt-2">
      <b-col :cols="9">
        <b-pagination
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total-rows="rowCount"/>
      </b-col>
      <b-col :cols="3" class="text-right" v-if="enableDownload">
        <!-- <b-button
          @click="download"
          variant="primary"
          size="small">
          Download as CSV
        </b-button> -->
      </b-col>
    </b-row>
    <div v-if="data_gotten != null">
        <nested-table
          :nested_data="data_gotten"
          :_key="table_key"
          :table_name="table_name"
          @close="data_gotten = null"/>
    </div>

    <div v-if="isLoadingPage"
         style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;
         background: rgba(255, 255, 255, .3); border-radius: 5px;">
      <align-middle>
        <div class="text-center">
          <strong class="fa fa-3x fa-spin fa-spinner"/>
        </div>
      </align-middle>
    </div>
  </b-card>
</template>

<script>
  import {titleCase} from '../Insights/utils';
  import InsightsComputationMixin from '../Insights/InsightsComputationMixin';
  import {getCookie, setCookie} from '../../utils';
  import ListControl from '../Insights/ListControl';
  import AlignMiddle from '../Sources/AlignMiddle';
  import NestedTable from './NestedTable';

  function Fetch(params) {
  }

  export default {
    name: 'List',

    components: {
      AlignMiddle,
      ListControl,
      NestedTable
    },

    mixins: [
      InsightsComputationMixin
    ],

    props: {
      enableFilter: Boolean,
      enableDownload: Boolean,
      enableAction: Boolean,
      enableSort: Boolean,
      defaultSortBy: String,
      defaultColumns: Array,
      fetch: {
        type: Fetch,
        required: true
      },
      fileType: {
        type: String,
        required: true
      },
      database: {
        type: String,
        required: true
      },
      actionText: String
    },

    data() {
      return {
        data_gotten: null,
        items: null,
        rowCount: 0,
        table_key:null,
        table_name:null,
        columns: [],
        search: '',
        sortBy: null,
        sortOrder: 0,
        rowsPerPage: 10,

        isLoadingPage: false,
        activeDataPage: 0,
        startPosition: 0,

        pagination: {
          perPage: 10,
          currentPage: 1
        },

        titleCase
      };
    },

    created() {
      this.readFromFakeMemory();
      this.doColumnsCleanup();
    },

    watch: {
      allColumns() {
        this.doColumnsCleanup();
      },

      columns() {
        this.updateFakeMemory();
      },

      'pagination.currentPage'(page) {
        const dataPage = page - 1;
        const activePage = this.activeDataPage;
        if (dataPage !== activePage) {
          this.computeInsightsData(dataPage);
          setTimeout(() => {
            if (activePage === this.activeDataPage) {
              this.isLoadingPage = true;
            }
          }, 500);
        }
      }
    },

    methods: {
      checkArrayContainsObject(label){
       return Object.prototype.toString.call(label) === '[object Array]' && Object.prototype.toString.call(label[0]) === '[object Object]' ;
      },
      checkArrayContainsIDs(label){
       return Object.prototype.toString.call(label) === '[object Array]' && Object.prototype.toString.call(label[0]) != '[object Object]' ;
      },
      isObject(label){
       return Object.prototype.toString.call(label) == '[object Object]' ;
      },

      open_table(x=null){
        if (this.checkArrayContainsObject(x.value)){
            this.data_gotten = x.value;
        }
        else if (this.checkArrayContainsIDs(x.value)){
          this.data_gotten = x.value.map(name => ({list_items:name}));
        }
        else if(this.isObject(x.value)){
          this.data_gotten = [x.value];

        }

        this.table_key = (new Date()).getMilliseconds().toString();
        this.table_name = x.field.label;
      },

      resetInsightsData() {
        this.items = null;
        this.rowCount = 0;
      },

      makeSortParams() {
        const sort = parseInt(this.sortOrder);
        return this.enableSort ? {
          sort_by: this.sortBy,
          sort_asc: isNaN(sort) ? 0 : sort
        } : {};
      },

      makeFilterParams() {
        return this.enableFilter ? {
          search: this.search,
          search_on: this.columns
        } : {};
      },

      computeInsightsData(dataPage = 0) {
        const n = parseInt(this.rowsPerPage);
        const pageSize = n && !isNaN(n) ? n : 10;

        const params = {
          page: dataPage,
          page_size: pageSize,
          ...this.makeSortParams(),
          ...this.makeFilterParams()
        };

        this.updateFakeMemory();

        this.fetch(params)
          .then(({items, totalCount}) => {
            this.items = items;
            this.rowCount = totalCount;
          })
          .catch(() => {
            this.items = [];
          })
          .finally(() => {
            this.startPosition = dataPage * pageSize;
            this.isLoadingPage = false;
            this.activeDataPage = dataPage;
            this.pagination = {
              perPage: pageSize,
              currentPage: dataPage + 1
            };
          });
      },

      handleApply() {
        this.compute(true);
      },

      download() {
        this.$emit('download', {
          ...this.makeFilterParams(),
          ...this.makeSortParams()
        });
      },

      act(record) {
        console.log("record", record);
        this.$emit('act', record);
      },

      doColumnsCleanup() {
        const columns = this.allColumns;
        const exists = slug => !!columns.find(col => col.slug === slug);

        this.columns = this.columns.filter(exists);
        if (this.columns.length === 0) {
          this.columns =
            this.defaultColumns && this.defaultColumns.length > 0 ?
              [...this.defaultColumns] :
              columns.slice(0, 6)
                .map(col => col.slug);
        }

        if (!this.sortBy || !exists(this.sortBy)) {
          this.sortBy = this.defaultSortBy || null;
        }
      },

      updateFakeMemory() {
        setCookie(this.cookieKey, JSON.stringify({
          page_size: this.rowsPerPage,
          sort_by: this.sortBy,
          sort_asc: this.sortOrder,
          columns: this.columns,
          search: this.search
        }));
      },

      readFromFakeMemory() {
        // try {
        //   const memory = JSON.parse(getCookie(this.cookieKey));
        //   if (memory) {
        //     this.columns = memory.columns;
        //     this.rowsPerPage = memory.page_size;
        //     this.sortBy = memory.sort_by;
        //     this.sortOrder = memory.sort_asc;
        //     this.search = memory.search || '';
        //   }
        // } catch (e) {
        // }
      }
    },

    computed: {
      cookieKey() {
        return `_fake_mem_${this.fileType}_6`;
      },

      allColumns() {
        return this.$store.getters.fileColumns(this.fileType, true);
      },

      tableFields() {
        const colMap = this.allColumns.reduce(
          (map, col) => ({...map, [col.slug]: titleCase(col.name)}),
          {});
        console.log("thiscolumns", this.columns);
        return this.columns.map(slug => ({
          key: slug,
          label: colMap[slug],
          sortable: false
        }));
      },

      tableFieldLabels() {
        let labels = {}
        this.tableFields.forEach(field => {
          labels[field.key] = field.label;
        });
        return labels;
      },

      sortByColumns() {
        return this.tableFields.map(
          ({key, label}) => ({value: key, text: label}));
      }
    }
  };
</script>

<style scoped lang="css">
@media screen and (max-width: 768px) {
  .alt-table-responsive table thead {
    display: none;
  }

  .alt-table-responsive table tr {
    display: block;
    border-top: 2px solid lightgray;
    margin-top: 5px;
  }

  .alt-table-responsive table td {
    display: block;
    text-align: right;
  }

  .alt-table-responsive table td:before {
    content: attr(data-label);
    float: left;
    font-weight: 700;
  }
}
</style>
